<ng-container *transloco="let t; read: 'assignment'" >
    <ng-container *ngIf="vm$ | async as vm">
    
    <h2>{{t('report')}}</h2>

    <div style="width:400px">
        <kendo-lineargauge 
            [pointer]="{ value: vm.calculatedTimes.usedPercentage, shape: 'arrow' }"
            [scale]="{ vertical: false }"
            [transitions]="false">

            <kendo-lineargauge-scale 
                [majorUnit]="20" 
                [minorUnit]="20"
                [max]="vm.calculatedTimes.usedPercentage <= 100 ? 100 : vm.calculatedTimes.usedPercentage">

                <kendo-lineargauge-scale-ranges>
                    <kendo-lineargauge-scale-range [from]="80" [to]="100" color="#fdce3e">
                    </kendo-lineargauge-scale-range>
                    <kendo-lineargauge-scale-range
                        [from]="100"
                        color="#d51923"
                    >
                    </kendo-lineargauge-scale-range>
                </kendo-lineargauge-scale-ranges>
            </kendo-lineargauge-scale>
        </kendo-lineargauge>
        <span>Fortschritt in %</span>
    </div>

    
    <div class="grid col2 mtm" style="width:400px">
        <div>Soll Zeit</div>
        <div>{{vm.assignment.defaultTimeTotal | timeSpanToString}}</div>

        <div>Ist Zeit Dienstleistungen</div>
        <div>{{vm.assignment.timeEntriesTotal | timeSpanToString}}</div>

        <div>Ist Zeit Auftrag</div>
        <div [ngClass]="usedPercentageClass(vm.calculatedTimes.usedPercentage)">{{vm.assignment.totalTimeObj | timeSpanToString}} ({{vm.calculatedTimes.usedPercentage}}%) </div>

        <div>Differenz Soll / Ist</div>
        <div>{{vm.calculatedTimes.totalTimeDifference | timeSpanToString}} ({{vm.calculatedTimes.availablePercentage}}%)</div>
    </div>

    <!-- Grouped by Activity -->
    <ng-container *ngIf="vm.groupedByActivity.length > 0">
      <div *ngFor="let activity of vm.groupedByActivity" class="activity-group mtm">
        <h3>{{ activity.activityName }}</h3>
        
        <div class="grid col5">
          <span><strong>{{t('employee')}}</strong></span>
          <span><strong>{{t('timespan')}}</strong></span>
          <span><strong>{{t('duration')}}</strong></span>
          <span><strong>{{t('internalCost')}}</strong></span>
          <span><strong>{{t('externalCost')}}</strong></span>

          <ng-container *ngFor="let emp of activity.employees">
            <span>{{ emp.employeeName }}</span>
            <span>
              {{ emp.dateFrom | date: "dd.MM.yyyy" }}
              <ng-container *ngIf="(emp.dateFrom | date:'yyyyMMdd') !== (emp.dateTo | date:'yyyyMMdd')">
                - {{ emp.dateTo | date: "dd.MM.yyyy" }}
              </ng-container>
            </span>
            <span>{{ emp.duration }}</span>
            <span>{{ emp.costInternal | currency:'CHF':'symbol':'1.2-2' }}</span>
            <span>{{ emp.costExternal | currency:'CHF':'symbol':'1.2-2' }}</span>
          </ng-container>

          <!-- Activity subtotal -->
          <span><strong>Subtotal</strong></span>
          <span></span>
          <span><strong>{{ activity.totalDuration }}</strong></span>
          <span><strong>{{ activity.totalCostInternal | currency:'CHF':'symbol':'1.2-2' }}</strong></span>
          <span><strong>{{ activity.totalCostExternal | currency:'CHF':'symbol':'1.2-2' }}</strong></span>
        </div>
      </div>

      <!-- Grand Total -->
      <div class="grid col5 mtm grand-total">
        <span><strong>Total</strong></span>
        <span></span>
        <span><strong>{{ vm.totals.duration }}</strong></span>
        <span><strong>{{ vm.totals.costInternal | currency:'CHF':'symbol':'1.2-2' }}</strong></span>
        <span><strong>{{ vm.totals.costExternal | currency:'CHF':'symbol':'1.2-2' }}</strong></span>
      </div>
    </ng-container>

</ng-container>
</ng-container>